module.exports = __webpack_public_path__ + "cea08aabf611ab93a3ddc3925b5614a8.ttf";